import {connect} from 'react-redux';
import MaterialAction from "./MaterialAction";
import {bindActionCreators} from 'redux';
import {
    getMaterialForGateList,
    saveBarcodeHistory,
    saveSiteVerification
} from "../../../services/redux/ContractAssetsMapping/action";
import {documentUploadUrl, imageUploadUrlPublic} from "../../../services/redux/fileUpload/action";

const mapStateToProps = (state) => ({
    material: state.contractAssetsMapping.material,
    barcodeHistoryResponse: state.contractAssetsMapping.barcodeHistoryResponse,
    siteVerification: state.contractAssetsMapping.siteVerification,
    documentUrlData: state.fileUploadReducer.imageUrlData,
});

const mapDispatchToProps = (dispatch) =>
    bindActionCreators(
        {
            getMaterialForGateList,
            saveBarcodeHistory,
            saveSiteVerification,
            documentUploadUrl,
            imageUploadUrlPublic
        },
        dispatch
    );

export default connect(mapStateToProps, mapDispatchToProps)(MaterialAction);
